import React from 'react'
import { useIntl } from 'react-intl';
import Hero from '../components/Hero';

export type AboutUsPageProps = {};

const AboutUsPage: React.FC<AboutUsPageProps> = () => {
  const intl = useIntl();
  return (
    <div className="w-full">
      <Hero bgImage={'/img/office-scene.png'} heading={intl.formatMessage({id: 'about-us2'})} />
      <div className="w-full flex flex-col items-center justify-center bg-main p-5 relative min-h-[200px]">
        <h1 className='text-2xl uppercase mb-4 text-secondary font-semibold text-center'>
          {intl.formatMessage({
            id: 'welcome-to',
            defaultMessage: "Welcome to Mexico Certifying Body S.C."
          })}
        </h1>
        <hr className='w-60 border-white -mt-3 mb-6'/>
        <h3 className='max-w-5xl text-white text-lg text-center px-20' dangerouslySetInnerHTML={{__html: intl.formatMessage({
            id: 'about_us_intro_1',
            defaultMessage: "Mexico Certifying Body was created in Mexico City to support and serve the Electronic, Telecommunications, and Information Technology industries with the aim of contributing to Mexico's technological growth; ensuring compliance with the Official Mexican Standards (NOM) and other current legislation to provide protection to consumers, the environment, and guarantee the proper use of the public telecommunications network."
        })}}></h3>
        <h3 className='max-w-5xl text-white text-lg text-center px-20 mt-6' dangerouslySetInnerHTML={{__html: intl.formatMessage({
            id: 'about_us_intro_2',
            defaultMessage: "Mexico Certifying Body was created in Mexico City to support and serve the Electronic, Telecommunications, and Information Technology industries with the aim of contributing to Mexico's technological growth; ensuring compliance with the Official Mexican Standards (NOM) and other current legislation to provide protection to consumers, the environment, and guarantee the proper use of the public telecommunications network."
        })}}></h3>
        <img className="absolute left-0 bottom-0" src="/icons/home-hero-grid-accent.svg" alt="" />
      </div>
      <div className="w-full flex flex-col md:flex-row items-center justify-center gap-4 max-w-5xl py-12 m-auto">
        <div className="bg-gray-200 border-b-8 p-8 border-color-secondary h-[400px] w-full md:w-1/2 flex flex-col items-center justify-center text-center">
          <h3 className="text-secondary text-2xl mb-10 font-bold uppercase">
            {
              intl.formatMessage({
                id: 'mission',
                defaultMessage: 'Mission',
              })
            }
          </h3>
          <p>
            {
              intl.formatMessage({
                id: 'mission_stmt',
                defaultMessage: 'Represent the highest quality in product certification to the Mexican population, complying with the processes regarding regulations and legislation. Providing security and trust of evaluated products, thus facilitating trade and growth from the country.'
              })
            }
          </p>
          <img className="mt-10" src="/mcb-darker.svg" alt="" />
        </div>
        <div className="bg-gray-200 border-b-8 p-8 border-color-secondary h-[400px] w-full md:w-1/2 flex flex-col items-center justify-center text-center">
          <h3 className="text-secondary text-2xl mb-10 font-bold uppercase">
            {
              intl.formatMessage({
                id: 'vision',
                defaultMessage: 'Vision',
              })
            }
          </h3>
          <p>
            {
              intl.formatMessage({
                id: 'vision_stmt',
                defaultMessage: 'To be a product certification body with presence National and international. Leader in innovation and excellence in Conformity Assessment eliminating bureaucratic barriers and simplifying regulatory processes for the benefit of the entire industry.'
              })
            }
          </p>
          <img className="mt-10" src="/mcb-darker.svg" alt="" />
        </div>
      </div>
      <div className="w-full min-h-[500px] bg-secondary flex flex-col items-center justify-center p-4 lg:p-8">
        <h3 className="uppercase text-white text-2xl">
          {
            intl.formatMessage({
              id: 'values',
              defaultMessage: 'Values',
            })
          }
        </h3>
        <div className="w-full inline-flex flex-row flex-wrap items-center justify-center mt-4 max-w-7xl">
          <div className="w-full sm:w-1/2 lg:w-1/3 xl:w-1/4 p-2">
            <div className="w-full derp bg-gray-200 flex flex-col items-center justify-center px-4 py-8 border-b-8 border-color-main text-center">
              <h4 className="font-semibold mb-6 uppercase">
                {
                  intl.formatMessage({
                    id: 'impartiality',
                    defaultMessage: 'Impartiality'
                  })
                }
              </h4>
              <p className="min-h-[150px] flex items-center justify-center px-10">
                {
                  intl.formatMessage({
                    id: 'impartiality_sub',
                    defaultMessage: 'Total neutrality in internal processes.'
                  })
                }
              </p>
              <img className="mt-10" src="/mcb-darker.svg" alt="" />
            </div>
          </div>
          <div className="w-full sm:w-1/2 lg:w-1/3 xl:w-1/4 p-2">
            <div className="w-full derp bg-gray-200 flex flex-col items-center justify-center px-4 py-8 border-b-8 border-color-main text-center">
              <h4 className="font-semibold mb-6 uppercase">
                {
                  intl.formatMessage({
                    id: 'integrity',
                    defaultMessage: 'Integrity'
                  })
                }
              </h4>
              <p className="min-h-[150px] flex items-center justify-center px-10">
                {
                  intl.formatMessage({
                    id: 'integrity_sub',
                    defaultMessage: 'Always doing the right thing in all circumstances'
                  })
                }
              </p>
              <img className="mt-10" src="/mcb-darker.svg" alt="" />
            </div>
          </div>
          <div className="w-full sm:w-1/2 lg:w-1/3 xl:w-1/4 p-2">
            <div className="w-full derp bg-gray-200 flex flex-col items-center justify-center px-4 py-8 border-b-8 border-color-main text-center">
              <h4 className="font-semibold mb-6 uppercase">
                {
                  intl.formatMessage({
                    id: 'trust',
                    defaultMessage: 'Trust'
                  })
                }
              </h4>
              <p className="min-h-[150px] flex items-center justify-center px-10">
                {
                  intl.formatMessage({
                    id: 'trust_sub',
                    defaultMessage: 'Earning the loyalty of our users daily'
                  })
                }
              </p>
              <img className="mt-10" src="/mcb-darker.svg" alt="" />
            </div>
          </div>
          <div className="w-full sm:w-1/2 lg:w-1/3 xl:w-1/4 p-2">
            <div className="w-full derp bg-gray-200 flex flex-col items-center justify-center px-4 py-8 border-b-8 border-color-main text-center">
              <h4 className="font-semibold mb-6 uppercase">
                {
                  intl.formatMessage({
                    id: 'excellence',
                    defaultMessage: 'Excellence'
                  })
                }
              </h4>
              <p className="min-h-[150px] flex items-center justify-center px-10">
                {
                  intl.formatMessage({
                    id: 'excellence_sub',
                    defaultMessage: 'Commitment to having the most qualified staff'
                  })
                }
              </p>
              <img className="mt-10" src="/mcb-darker.svg" alt="" />
            </div>
          </div>
          <div className="w-full sm:w-1/2 lg:w-1/3 xl:w-1/4 p-2">
            <div className="w-full derp bg-gray-200 flex flex-col items-center justify-center px-4 py-8 border-b-8 border-color-main text-center">
              <h4 className="font-semibold mb-6 uppercase">
                {
                  intl.formatMessage({
                    id: 'efficiency',
                    defaultMessage: 'Efficiency'
                  })
                }
              </h4>
              <p className="min-h-[150px] flex items-center justify-center px-10">
                {
                  intl.formatMessage({
                    id: 'efficiency_sub',
                    defaultMessage: 'Devotion to constant innovation and continuous improvement of results'
                  })
                }
              </p>
              <img className="mt-10" src="/mcb-darker.svg" alt="" />
            </div>
          </div>
          <div className="w-full sm:w-1/2 lg:w-1/3 xl:w-1/4 p-2">
            <div className="w-full derp bg-gray-200 flex flex-col items-center justify-center px-4 py-8 border-b-8 border-color-main text-center">
              <h4 className="font-semibold mb-6 uppercase">
                {
                  intl.formatMessage({
                    id: 'responsibility',
                    defaultMessage: 'Responsibility'
                  })
                }
              </h4>
              <p className="min-h-[150px] flex items-center justify-center px-10">
                {
                  intl.formatMessage({
                    id: 'responsibility_sub',
                    defaultMessage: 'Taking our obligations seriously'
                  })
                }
              </p>
              <img className="mt-10" src="/mcb-darker.svg" alt="" />
            </div>
          </div>
          <div className="w-full sm:w-1/2 lg:w-1/3 xl:w-1/4 p-2">
            <div className="w-full derp bg-gray-200 flex flex-col items-center justify-center px-4 py-8 border-b-8 border-color-main text-center">
              <h4 className="font-semibold mb-6 uppercase">
                {
                  intl.formatMessage({
                    id: 'collaboration',
                    defaultMessage: 'collaboration'
                  })
                }
              </h4>
              <p className="min-h-[150px] flex items-center justify-center px-10">
                {
                  intl.formatMessage({
                    id: 'collaboration_sub',
                    defaultMessage: 'Multiplying internal and external results with a common goal'
                  })
                }
              </p>
              <img className="mt-10" src="/mcb-darker.svg" alt="" />
            </div>
          </div>
          <div className="w-full sm:w-1/2 lg:w-1/3 xl:w-1/4 p-2">
            <div className="w-full derp bg-gray-200 flex flex-col items-center justify-center px-4 py-8 border-b-8 border-color-main text-center">
              <h4 className="font-semibold mb-6 uppercase">
                {
                  intl.formatMessage({
                    id: 'gratitude',
                    defaultMessage: 'Gratitude'
                  })
                }
              </h4>
              <p className="min-h-[150px] flex items-center justify-center px-10">
                {
                  intl.formatMessage({
                    id: 'gratitude_sub',
                    defaultMessage: 'Daily gratitude for the opportunity to be part of the industry and make a difference in the lives of others'
                  })
                }
              </p>
              <img className="mt-10" src="/mcb-darker.svg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutUsPage;
